import React, { Component } from 'react'
import autobind from 'autobind-decorator'
import PropTypes from 'prop-types'

@autobind
class SearchNotFound extends Component {
  constructor (props) {
    super(props)
    this.state = {filtersApplied: []}
  }

  componentWillMount () {
    /* let filters = {resource: this.props.resourceId, school: this.props.schoolId, age: this.props.filters.yeargroup, bookmark: this.props.filters.bookmark, exemplar: this.props.filters.exemplar}
    let filtersApplied = []
    for (let filter in filters) {
      filters[filter] && filtersApplied.push(filter)
    }
    this.setState({filtersApplied}) */
  }

  render () {
    let noStories = `We have no pieces of work about ${this.props.query || 'this'}.`

    return (
      <div className='search-not-found'>
        <img src='/images/search/octopus.png' alt='Search not found' />
        <p>
          <strong>We've searched everywhere...</strong>
          <span>{noStories} Please <a href='/'>try again</a>.</span>
        </p>
        {/* <p>
          <strong>{noStories}</strong>
          {this.state.filtersApplied.length > 0 && <span>You filtered by {this.state.filtersApplied.join(', ')}. <a href={this.props.query ? `/search/${this.props.query}` : '/'}>Reset filters</a></span>}
          <span>There's a lot to discover! <a href='/'>Start a new search</a></span>
        </p>*/}
      </div>
    )
  }
}

export default SearchNotFound

SearchNotFound.propTypes = {
  query: PropTypes.string,
  resourceId: PropTypes.string,
  schoolId: PropTypes.string,
  filters: PropTypes.object
}



// WEBPACK FOOTER //
// ./components/search/notFound.js